import React, { CSSProperties, FC } from 'react';
import styles from '../ImageGallery.module.scss';

interface MobileScrollbarProps {
  scrollbarRef: React.RefObject<HTMLDivElement | null>;
  thumbStyle: CSSProperties;
  onPointerDown: (event: React.PointerEvent<HTMLDivElement>) => void;
}

const MobileScrollbar: FC<MobileScrollbarProps> = ({
  scrollbarRef,
  thumbStyle,
  onPointerDown,
}) => {
  return (
    <div
      ref={scrollbarRef}
      className={styles.mobileScrollbar}
      aria-hidden
      onPointerDown={onPointerDown}
    >
      <div className={styles.mobileScrollbarThumb} style={thumbStyle} />
    </div>
  );
};

export default MobileScrollbar;
